import React from 'react'
import styled from 'styled-components'

import { translateLKM } from './helpers'
import LKModal, { LKModalContainer } from '../shared/LKModal'
import { useTicker } from '../../hooks'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .timeout-logo {
    margin: 0 20px;
    width: 150px;
  }
`

const Ticker = () => {
  const secondsLeft = useTicker(30)

  return <span>{`დარჩენილი დრო: ${secondsLeft}`}</span>
}

const NoActivityWarning = ({ modalInstanceName }) => (
  <LKModal icon="alert" name={modalInstanceName} heading={translateLKM('MSG_WARNING')} size="xs">
    <Wrapper>
      <img className="timeout-logo" src="/static/img/test_logo.png" alt="logo" />
      <div>
        <p>სესიას ვადა გასდის (უმოქმედობის გამო)</p>
        <Ticker />
      </div>
    </Wrapper>
  </LKModal>
)

const DecoratedNoActivityWarning = LKModalContainer('NoActivityWarning')(NoActivityWarning)

export default DecoratedNoActivityWarning
